import { useCallback } from "react";

/**
 * 指定IDの要素まで window をスクロールする
 */
const useScrollToAnchor = () => {
  return useCallback((id, { offset = 0, behavior = "smooth" } = {}) => {
    // 再描画・レイアウト確定後に実行
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const el = document.getElementById(id);
        if (!el) return;

        const y = el.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: y, behavior });
      });
    });
  }, []);
};

export default useScrollToAnchor;
